module.exports = __webpack_public_path__ + "static/media/rider_mark_reached.f8cc1b16.svg";